(function () {
  // Multiple named lists (by room, age group, learning area, service), stored in this browser.
  // Shape: { lists: [{ id, name, items: [handle, ...] }] }
  const KEY = 'theme:wishlists:v2';
  const LEGACY_KEY = 'theme:wishlist:v1'; // old single-list format, migrated into the first list
  const DEFAULT_NAME = 'My Wishlist';

  function uid() {
    return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  function parse(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }

  function load() {
    let state = parse(KEY);
    if (!state || !Array.isArray(state.lists)) {
      const legacy = parse(LEGACY_KEY);
      state = { lists: [{ id: uid(), name: DEFAULT_NAME, items: Array.isArray(legacy) ? legacy : [] }] };
      persist(state);
    }
    if (!state.lists.length) {
      state.lists.push({ id: uid(), name: DEFAULT_NAME, items: [] });
      persist(state);
    }
    return state;
  }

  function persist(state) {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function save(state) {
    persist(state);
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: read() }));
  }

  function cleanName(name) {
    return String(name || '').trim().slice(0, 60);
  }

  function find(state, id) {
    return state.lists.find(l => l.id === id);
  }

  // ---- Lists ----
  function getLists() {
    return load().lists.map(l => ({ id: l.id, name: l.name, items: l.items.slice() }));
  }

  function getList(id) {
    return getLists().find(l => l.id === id) || null;
  }

  function createList(name, items) {
    const state = load();
    const list = { id: uid(), name: cleanName(name) || 'Untitled list', items: [] };
    (items || []).forEach(h => { if (h && !list.items.includes(h)) list.items.push(h); });
    state.lists.push(list);
    save(state);
    return list.id;
  }

  function renameList(id, name) {
    const state = load();
    const list = find(state, id);
    if (!list || !cleanName(name)) return;
    list.name = cleanName(name);
    save(state);
  }

  function deleteList(id) {
    const state = load();
    state.lists = state.lists.filter(l => l.id !== id);
    save(state);
  }

  function addTo(id, handle) {
    const state = load();
    const list = find(state, id);
    if (!list || !handle || list.items.includes(handle)) return;
    list.items.push(handle);
    save(state);
  }

  function removeFrom(id, handle) {
    const state = load();
    const list = find(state, id);
    if (!list) return;
    list.items = list.items.filter(h => h !== handle);
    save(state);
  }

  function listsContaining(handle) {
    return load().lists.filter(l => l.items.includes(handle)).map(l => l.id);
  }

  // ---- All-lists helpers (kept compatible with the old single-list API) ----
  function read() {
    const all = [];
    load().lists.forEach(l => l.items.forEach(h => { if (!all.includes(h)) all.push(h); }));
    return all;
  }

  function has(handle) {
    return read().includes(handle);
  }

  function add(handle) {
    addTo(load().lists[0].id, handle);
  }

  function remove(handle) {
    const state = load();
    state.lists.forEach(l => { l.items = l.items.filter(h => h !== handle); });
    save(state);
  }

  function toggle(handle) {
    if (!handle) return;
    has(handle) ? remove(handle) : add(handle);
  }

  // Expose a tiny API
  window.Wishlist = {
    read, add, remove, toggle, has,
    getLists, getList, createList, renameList, deleteList, addTo, removeFrom, listsContaining
  };
})();
